export default class CsConstant {
  static HEADER_STORE_NAME = 'X-Cs-Store';
  static HEADER_HASHED_STORE = 'X-Cs-Token';
  static STRAPI_RESOURCES_DOCS = 'shopifylegaldocs';
  static DOCS_EXPIRE_TIME = 7 * 24 * 3600 * 1000; // 7 days
  static TRANSLATION_EXPIRE_TIME = 7 * 24 * 3600 * 1000;  // 7 days
  static TRANSLATION_LAST_UPDATE = '2021-09-21 11:00:00'; // Can put the local time, no worry about timezone

  static SENTRY_DNS = 'https://2da3d2677e8d403796e9d97697867526@o468350.ingest.sentry.io/5496015';
}
